module.exports = __webpack_public_path__ + "static/media/Chevron-Left.2cef7a91.svg";